export default __webpack_public_path__ + "/dist/images/market-place.f960f7e6ead3a4a7fccb30f7739c1d31.png";